import like from '../../assets/icons/like.png'
const VisitsBox = ({number}) => {
    return(
        <div
        className='bg-[#f3f3f3] rounded-[15px]
        p-6 mt-7 flex justify-between'>
            <p>
                تعداد ویزیت آنلاین در مدیزن:
            </p>
            <div
            className='flex items-center text-aqua gap-1'
            >
                <p>
                    {number}
                </p>
                <img
                src={like}
                className='w-[20px]'
                />
            </div>
        </div>
    )
}
export default VisitsBox